import { SxProps } from '@mui/material'
import { navigationMenuClasses } from '../NavigationMenu/NavigationMenu.data'

interface MobileNavigationMenuStyles {
  wrapper: SxProps
}

export const mobileNavigationMenuStyles: MobileNavigationMenuStyles = {
  wrapper: {
    display: { xs: 'flex', lg: 'none' },
    position: 'relative',

    [`.${navigationMenuClasses.hamburgerMenuIcon}`]: {
      cursor: 'pointer',
      width: 24,
      color: 'pageTheme.secondaryColor',
    },
  },
}
